import { useState } from 'react';

import { Edit16 } from 'ui/icons';
import { ModalConfirmationFooter, ModalFooter, ConfirmationPrompt } from 'ui/modal';
import { PrimaryButton, GhostButton, BUTTON_SIZES, SecondaryDestructiveButton } from 'ui/button';
import { AssetManagerModal } from 'modules/assetManager/components/AssetManagerModal';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { ContactCardForm } from './ContactCardForm';
import { ContactCardListEntry } from './ContactCardListEntry';
import { useContactCardContext } from '../contexts/ContactCardContext';
import { StyledSecondaryButton } from './ContactCards.styles';

export const MANAGE_CONTACT_CARD_MODAL_CONTENT = {
  headerText: 'Manage contact cards',
  cancelButtonText: 'Cancel',
  saveButtonText: 'Save',
  editButtonText: 'Edit',
  addButtonText: 'Add to template',
  deleteButtonText: 'Delete contact card',
};

const ModalActionsFooter = () => {
  const { isEditing, setIsEditing, save, cancel, selectedAssetId, setIsModalOpen, deleteAsset } =
    useContactCardContext();
  const { setCurrentMediumField } = useEditableFieldsContext();
  const [deletePromptIsShown, setDeletePromptIsShown] = useState(false);

  const handleAddToTemplate = () => {
    setCurrentMediumField('verifiedContactCardId', selectedAssetId);
    setIsModalOpen(false);
  };

  const handleDeleteClick = () => {
    setDeletePromptIsShown(false);
    deleteAsset(selectedAssetId as number);
  };

  if (isEditing) {
    return (
      <ModalConfirmationFooter
        promptType={deletePromptIsShown ? ConfirmationPrompt.DISCARD : ConfirmationPrompt.NONE}
        onDiscard={handleDeleteClick}
        onResume={() => setDeletePromptIsShown(false)}
        discardLabel="Are you sure?"
        resumeButtonLabel="Cancel"
        discardButtonLabel="Delete contact card"
        discardHelpText="This will impact everywhere this contact card is used and cannot be undone."
      >
        <GhostButton onClick={cancel} size={BUTTON_SIZES.LARGE}>
          {MANAGE_CONTACT_CARD_MODAL_CONTENT.cancelButtonText}
        </GhostButton>
        {selectedAssetId && (
          <SecondaryDestructiveButton
            onClick={() => setDeletePromptIsShown(true)}
            size={BUTTON_SIZES.LARGE}
          >
            {MANAGE_CONTACT_CARD_MODAL_CONTENT.deleteButtonText}
          </SecondaryDestructiveButton>
        )}
        <PrimaryButton onClick={() => save()} size={BUTTON_SIZES.LARGE}>
          {MANAGE_CONTACT_CARD_MODAL_CONTENT.saveButtonText}
        </PrimaryButton>
      </ModalConfirmationFooter>
    );
  }

  return (
    <ModalFooter hasCancel={false}>
      <GhostButton onClick={() => setIsModalOpen(false)} size={BUTTON_SIZES.LARGE}>
        {MANAGE_CONTACT_CARD_MODAL_CONTENT.cancelButtonText}
      </GhostButton>
      <StyledSecondaryButton onClick={() => setIsEditing(true)} size={BUTTON_SIZES.LARGE}>
        <Edit16 />
        {MANAGE_CONTACT_CARD_MODAL_CONTENT.editButtonText}
      </StyledSecondaryButton>
      <PrimaryButton onClick={handleAddToTemplate} size={BUTTON_SIZES.LARGE}>
        {MANAGE_CONTACT_CARD_MODAL_CONTENT.addButtonText}
      </PrimaryButton>
    </ModalFooter>
  );
};

export const ManageContactCardModal = () => {
  const { setIsModalOpen } = useContactCardContext();

  return (
    <AssetManagerModal
      id="sms-contact-card"
      AssetForm={ContactCardForm}
      ListEntry={ContactCardListEntry}
      BottomActions={ModalActionsFooter}
      onClose={() => setIsModalOpen(false)}
    />
  );
};
